import useDataverseService from "../../services/DataverseService";
import { useAssignment } from "./useAssignment";

export const useReturn = () => {
  const { assignUser } = useAssignment();
  const dataverseService = useDataverseService();

  const handleReturn = async (
    ownerId: string,
    setLoading: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    const users = await dataverseService.getUsers();
    const owner = users.find((u: any) => u.systemuserid == ownerId);
    if (owner) {
      assignUser(owner, true, setLoading);
    }
  };

  return { handleReturn };
};
